const __vite_glob_0_13 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 7 12\">\n  <path d=\"M6.707 5.338 1.558.265A.92.92 0 0 0 .912 0a.908.908 0 0 0-.91.898.89.89 0 0 0 .265.633l4.502 4.49-4.502 4.444a.89.89 0 0 0 .294 1.464.915.915 0 0 0 .997-.198l5.149-5.074a.891.891 0 0 0 0-1.319Z\"/>\n</svg>\n";

export { __vite_glob_0_13 as default };
